import { useTranslations } from 'next-intl';
import { useRouter } from 'next/navigation';
import qs from 'qs';

import { snackbar } from '@flipster/react/design-system/snackbar';

import { emailSchema } from '@web/utils/session-validator';

function useClickSignUp() {
  const router = useRouter();
  const t = useTranslations();

  return ({ email }: { email: string }) => {
    try {
      emailSchema.validateSync(email);

      const queryString = qs.stringify({ email });
      router.push(`/email-signup?${queryString}`);
    } catch {
      const message = !email ? t('Common.r251104.Please_enter_your_email') : 'Invalid e-mail address.';
      snackbar.error({ message });
    }
  };
}

export default useClickSignUp;
